import React from 'react'

interface UnderlineLabelSectionProps {
  labelText: string
  children?: React.ReactNode
}

const UnderlineLabelSection: React.FC<UnderlineLabelSectionProps> = ({
  labelText, children
}) => {
  return (
    <div className="flex flex-col pb-4">
      <div className="flex flex-row">
        <label className="text-xl">{labelText}</label>
        {children}
      </div>
      <hr className="border border-wpy-gray mt-2" />
    </div>
  )
}

export default UnderlineLabelSection
